import { Query } from "react-apollo";
import gql from "graphql-tag";
import {  RouteVariable, RouteOutput, Employee } from "../../types/types";
import * as RouteHelpers from "../routes";
import { AboutRoutes } from "../../components/pages/About";
import { Connection } from "../graphql";

type QueryVariables = {
  routes: RouteVariable<AboutRoutes>[]
}


export type QueryResult = {
  routes: RouteOutput<AboutRoutes>[]
  employees: Connection<Employee>
}

export class AboutQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query About($routes: [RouteInput!]!) {
      routes: routes(routes: $routes) {
        url
        path
        name
        identifier
      }
      employees {
        nodes {
          name
          description
          image
        }
      }
    }
  `
}

const RoutesVariables = () : RouteVariable<AboutRoutes>[] => RouteHelpers.ToGraphqlVariable<AboutRoutes>({
  advertise: { "name": "advertise" },
  new_user_registration: { "name": "new_user_registration" },
})

export const variables = () : QueryVariables => {
  return {
    routes: RoutesVariables(),
  }
}
